import { render, staticRenderFns } from "./CardsFAQ.vue?vue&type=template&id=7dbfa472&scoped=true"
import script from "./CardsFAQ.vue?vue&type=script&lang=js"
export * from "./CardsFAQ.vue?vue&type=script&lang=js"
import style0 from "./CardsFAQ.vue?vue&type=style&index=0&id=7dbfa472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbfa472",
  null
  
)

export default component.exports